<template>
  <div class="Header">
    <div class="center">
      <div class="logo fl">
        <a class="a" @click="routerLink1"><img class="img" src="../assets/images/logo1.png"/></a>
      </div>
      <div class="nav fl">
        <el-menu
          ref="elMenu"
          :default-active="2"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#e1effe "
          text-color="#686868"
          active-text-color="white">
          <el-menu-item index="1" class="el-form-item" @click="routerLink('公司介绍','/gsjs/gsjs_info/0','0')">公司介绍</el-menu-item>
          <el-menu-item index="2" class="el-form-item" @click="routerLink('公司荣誉','/gsry/gsry_info/0','0')">公司荣誉</el-menu-item>
          <el-menu-item index="3" class="el-form-item" @click="routerLink('工程案例','/gcal/gcal_info/0','0')">工程案例</el-menu-item>
          <el-menu-item index="4" class="el-form-item" @click="routerLink('党建','/dj/dj_info/0','0')">党建</el-menu-item>
          <el-menu-item index="5" class="el-form-item" @click="routerLink('公司新闻','/gsxw/gsxw_info/0','0')">公司新闻</el-menu-item>
          <el-submenu index="6">
            <template slot="title">人力资源</template>
            <el-menu-item index="6-1" @click="routerLink('在线招聘','/rlzy/rlzy_info/0','0')">在线招聘</el-menu-item>
            <el-menu-item index="6-2" @click="routerLink('留言板','/rlzy/rlzy_info/1','1')">留言板</el-menu-item>
          </el-submenu>
          <el-menu-item index="7" class="el-form-item" @click="routerLink('信息公开','/xxgk/xxgk_info/0','0')">信息公开</el-menu-item>
          <!--<el-submenu index="1">-->
            <!--<template slot="title">轨道交通</template>-->
            <!--<el-menu-item index="1-1" @click="routerLink('施工','/gdjt/gdjt_info/0','0')">施工</el-menu-item>-->
            <!--<el-menu-item index="1-2" @click="routerLink('设计', '/gdjt/gdjt_info/1','1')">设计</el-menu-item>-->
            <!--<el-menu-item index="1-3" @click="routerLink('建设管理','/gdjt/gdjt_info/2','2')">建设管理</el-menu-item>-->
          <!--</el-submenu>-->
          <!--<el-menu-item index="2" @click="routerLink('生态修复','/about/about_info/0','0')">生态修复</el-menu-item>-->
          <!--<el-submenu index="3">-->
            <!--<template slot="title">招采信息</template>-->
            <!--<el-menu-item index="3-1" @click="routerLink('采购公告','/news/news_info/0','0')">采购公告</el-menu-item>-->
            <!--<el-menu-item index="3-2" @click="routerLink('补充公告','/news/news_info/1','2')">补充公告</el-menu-item>-->
            <!--<el-menu-item index="3-3" @click="routerLink('成交候选人公示','/news/news_info/2','2')">成交候选人公示</el-menu-item>-->
            <!--<el-menu-item index="3-4"><a class="a" href="http://gys.ranken.com.cn:8088/" target="_blank">供应商门户</a>-->
            <!--</el-menu-item>-->
          <!--</el-submenu>-->
          <!--<el-submenu index="4">-->
            <!--<template slot="title">工程案例</template>-->
            <!--<el-menu-item index="4-1" @click="routerLink('地下工程','/product/product_info/0','0')">地下工程</el-menu-item>-->
            <!--<el-menu-item index="4-2" @click="routerLink('道路桥梁','/product/product_info/1','1')">道路桥梁</el-menu-item>-->
            <!--<el-menu-item index="4-3" @click="routerLink('水工','/product/product_info/2','2')">水工</el-menu-item>-->
            <!--<el-menu-item index="4-4" @click="routerLink('工业与民用建筑','/product/product_info/3','3')">工业与民用建筑</el-menu-item>-->
          <!--</el-submenu>-->
          <!--<el-menu-item index="5" @click="routerLink('科技创新','/core/core_info/0','0')">科技创新</el-menu-item>-->
          <!--<el-submenu index="6">-->
            <!--<template slot="title">信息公开</template>-->
            <!--<el-menu-item index="6.1" @click="routerLink('公司新闻','/human/human_info/0','0')">公司新闻</el-menu-item>-->
            <!--<el-menu-item index="6.2" @click="routerLink('公司荣誉','/human/human_info/1','1')">公司荣誉</el-menu-item>-->
            <!--<el-menu-item index="6.3" @click="routerLink('公司介绍','/human/human_info/2','2')">公司介绍</el-menu-item>-->
            <!--<el-menu-item index="6.4" @click="routerLink('职工保护','/human/human_info/3','2')">职工保护</el-menu-item>-->
            <!--<el-menu-item index="6.5" @click="routerLink('在线招聘','/human/human_info/4','4')">在线招聘</el-menu-item>-->
          <!--</el-submenu>-->
          <!--<el-submenu index="7">-->
            <!--<template slot="title">企业党建</template>-->
            <!--<el-menu-item index="7-1" @click="routerLink('党旗飘扬','/contact/contact_info/0','0')">党旗飘扬</el-menu-item>-->
            <!--<el-menu-item index="7-2"  @click="routerLink('群团建设','/contact/contact_info/1','1')">群团建设</el-menu-item>-->
            <!--<el-menu-item index="7-3"  @click="routerLink('创先争优','/contact/contact_info/2','2')">创先争优</el-menu-item>-->
            <!--<el-menu-item index="7-4"  @click="routerLink('档案情怀','/contact/contact_info/3','3')">档案情怀</el-menu-item>-->
            <!--<el-menu-item index="7-5"  @click="routerLink('相关链接','/contact/contact_info/4','4')">相关链接</el-menu-item>-->
          <!--</el-submenu>-->
        </el-menu>
      </div>
      <div class="language rl">
        <ul>
          <li class="lang_li fl"><a class="color1" @click="routerLink1">首页</a></li>
          <!--<li class="lang_li fl" style="border-right:solid 0px #666666;"><a-->
            <!--class="color1">&nbsp;&nbsp;|&nbsp;&nbsp;下载</a></li>-->
          <!--<li class="lang_li fl"><a class="color1" href="http://e.ranken.com.cn">English</a></li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      currentIndex: 0,
      narArr: [
        // {
        //   path: '/',
        //   title: '首页'
        // },
        {
          path: '/gdjt',
          title: '轨道交通'
        },
        {
          path: '/about',
          title: '生态修复'
        },
        {
          path: '/news',
          title: '招采信息'
        },
        {
          path: '/product',
          title: '工程案例'
        },
        {
          path: '/core',
          title: '科技创新'
        },
        {
          path: '/human',
          title: '信息公开'
        },
        {
          path: '/contact',
          title: '企业党建'
        }
      ]
    };
  },
  methods: {
    routerLink(title, path, id) {
      let obj = {};
      obj.title = title;
      obj.path = path;
      let params = {};
      params.id = Number(id);
      obj.params = params;
      this.$router.push(obj);
    },
    routerLink1() {
      this.$refs.elMenu.activeIndex = null;
      let obj = {
        path: '/',
        title: '首页'
      };
      this.$router.push(obj);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .nav {
    margin-top: 18px;
    margin-left: 75px;
  }
  .el-menu-demo {
    /*width: 80%;*/
  }
  .el-menu-item {
    /*width: 19%;*/
  }
  .el-menu.el-menu--horizontal {
    border-bottom: solid 0px #e6e6e6;
  }

  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
    min-width: 120px !important;
    text-align: center !important;
  }

  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    background-color: #abb8c3 !important;
  }

  .el-menu-item.is-active {
    background-color: #abb8c3 !important;
  }

  .is-active.el-submenu__title {
    background-color: #abb8c3 !important;
  }

  .Header {
    height: auto;
    width: 100%;
    background: #e1effe;
  }

  .center {
    width: 1200px;
    height: 95px;
    margin: 0 auto;
  }

  .logo {
    width: 230px;
    height: 75px;
    margin: 10px auto;
    /*padding: 7px 40px;*/
  }

  .a {
    outline: none;
    text-decoration: none;
    color: #686868;
  }

  .img {
    width: 100%;
    margin: 20px;
    vertical-align: middle;
    border: none;
    cursor: pointer;
  }

  .fl {
    float: left;
  }

  .head_ul {
    list-style: none;
  }

  .nav_li {
    width: 103px;
    height: 75px;
    text-align: center;
  }

  .nav_a {
    line-height: 75px;
    font-size: 14px;
    transition: all 1s ease 0s;
  }

  .color1 {
    color: #686868;
  }

  .language {
    margin-right: 20px;
  }

  .rl {
    float: left;
  }

  .lang_li {
    margin-top: 31px;
    height: 14px;
    line-height: 14px;
  }

  ul {
    list-style: none;

    li {
      cursor: pointer
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue